export default class Expansion {
    constructor() {
        this.modal = document.querySelector('.c-expansionmodal');
        this.ajaxcontainer = document.querySelector('.c-expansionmodal__ajaxcontainer');
        this.init();
    }

    init() {
        if (this.modal) {
            this.eventBind();
        }
    }

    resetEvent() {
        this.eventBind('reset');
    }

    async setContent(type, category, index, subindex) {
        this.ajaxcontainer.innerHTML = '';
        const url = `/anime/2nd/_inc/common/modal/expansionmodal_contents.html?type=${type}&category=${category}&index=${index}&subindex=${subindex}`;
        console.log(url);
        const result = await fetch(url, {
            method: 'GET',
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const message = doc.body.innerHTML;
                return message;
            });
        this.ajaxcontainer.innerHTML = result;
        // window.modal.resetEvent();
    }

    eventBind(resetOption) {
        const openbuttons = [...document.querySelectorAll('.js-expansion_open')];
        const closebuttons = [...document.querySelectorAll('.js-expansion_close')];
        const _this = this;

        const handleOpen = function (e) {
            e.preventDefault();
            const type = this.el.getAttribute('data-type');
            const category = this.el.getAttribute('data-category');
            const index = this.el.getAttribute('data-index');
            const subindex = this.el.getAttribute('data-subindex');
            _this.setContent(type, category, index, subindex);
        };

        const handleClose = (e) => {};

        openbuttons.forEach((el) => {
            resetOption && el.removeEventListener('click', handleOpen);
            el.addEventListener('click', { el: el, handleEvent: handleOpen });
        });

        closebuttons.forEach((el) => {
            resetOption && el.removeEventListener('click', handleClose);
            el.addEventListener('click', handleClose);
        });
    }
}
